export const SINGLE_PADDING = '20px 0px';
export const WRAPPER_PADDING = '0px';
